exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".notification{background-color:#fff}.button:focus{background-color:unset}.bp-description{font-size:0.75rem;color:#666;padding:2px 0}.bp-page-header{font-size:1.5rem !important;color:#22a9e0;padding:10px 0 !important}\n", ""]);
